<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <br>
    <span class="fs-5 fw-bold" >
      (My Activity Report <i class="fa-solid fa-id-card color-green"></i>)
    </span>
    </div>
        <div class="row text-start" style="padding: 35px 18px 0px 5px;font-size:12px">
                  <div class="col-2 text-center" style="background-color: #EAEDED;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <i class="fas fa-user fa-xl"></i>
                    </label>
                  </div>
                  <div class="col-10 text-start" style="border-left: white solid 2px;padding-top:5px;background-color: #EAEDED;">
                    <b>{{ userInfomation }}</b>
                  </div>
        </div>    
        <div class="row" style="padding: 5px 18px 0px 5px;font-size:12px">
                  <div class="col-2 " style="background-color: #EAEDED;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <i class="fas fa-location-dot fa-xl"></i>
                    </label>
                  </div>
                  <div class="col-10 text-start" style="border-left: white solid 2px;padding-top:5px;background-color: #EAEDED;">
                    <b>{{ userArea }}</b>
                  </div>
        </div>  
        <div class="row" style="padding: 5px 18px 0px 5px">
                      <div class="col-2 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                          <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Month</span>
                        </label>
                      </div>
                      <div class="col-4 " style="height: 35px;">
                        <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;">{{ (selectedMonth&&selectedMonth.name?selectedMonth.name:'') }}</span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                          <li v-for="(month,index) in months" @click="selectedMonth=month" v-bind:key="index">
                            &nbsp;{{month.name}}⁣&nbsp;
                          </li>
                        </ul>
                      </div>
                      <div class="col-2 " style="padding: 0px;background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                          <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Year</span>
                        </label>
                      </div>
                      <div class="col-3 " style="padding: 0px;height: 35px;">
                        <input type="number" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" placeholder="Please enter year..." v-model="year" />
                      </div>
                      <div class="col-1 " style="padding: 0px;height: 35px;">
                        <button type="button" class="btn btn-success" @click="clickBtnSearch();">
                          <i class="fa-solid fa-search"></i>
                        </button>
                      </div>
        </div>      
        <br>
      
        <div class="row text-center" style="padding: 5px 0px 0px 5px;height: 40vh;overflow-y: scroll;">
          <table style="width:100%">
            <tr>
              <th v-for="day in daysOfWeek" :key="day" class="bg-primary" style="color:white;border:silver solid 1px;width:14.2%">{{ day }}</th>
            </tr>
            <tr v-for="week in weeksInCalendar" :key="week">
              <td v-for="day in week" :key="day.date" style="border:silver solid 1px;" 
              @click="clickDayInCalendar(day);">
                <div class="row" style="height: 15px;padding: 0px;">
                  <div class="col-12" style="padding: 0px;">
                    <div class="notification" v-if="day.totalSuveyCaseInDay">
                      <i class="fa-solid fa-briefcase fa-xl"></i>
                        <span class="badge">{{ day.totalSuveyCaseInDay }}</span>
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 15px;padding: 0px;">
                  <div class="col-6" style="padding: 0px;"></div>
                  <div class="col-6" style="padding: 0px;float: bottom;vertical-align: bottom;"><span style="font-size: 10px;color:grey;">{{ (day.date?day.date.getDate():'') }}</span></div>
                </div>
                
              </td>
            </tr>
          </table>
      </div>
      <div>
      <div v-for="(workData,index) in getTotalWorkByUser" v-bind:key="index" class="row" style="padding: 5px 18px 0px 5px;font-size:12px">
          <div class="col-10 " style="background-color: #EAEDED;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <b>{{ workData.work_type}}</b>
                    </label>
          </div>
          <div class="col-2 text-start" style="border-left: white solid 2px;padding-top:5px;background-color: #EAEDED;">
                    <b>{{ workData.total }}</b>
          </div>
      </div>   
      </div>
      <div v-if="totalSurveyCase" class="row" style="padding: 5px 18px 0px 5px;font-size:12px">
          <div class="col-10 bg-primary" style="color:white;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <i class="fa-solid fa-list"></i> <b>Total Activity</b>
                    </label>
          </div>
          <div class="col-2 text-start" style="border-left: white solid 2px;padding-top:5px;background-color: #EAEDED;">
                    <b>{{ totalSurveyCase }}</b>
          </div>
      </div>  
      <div class="row" style="padding: 5px 18px 0px 5px;font-size:12px">
        <div class="col-6 text-end">
          <button type="submit" class="btn btn-success" @click="exportReportDetails();" style="width:100%;" >
            <i class="fa-solid fa-file-excel"></i> Export Report
          </button>
        </div>
        <div class="col-6 text-start">
          <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:100%;" >
              <i class="fas fa-house"></i> Home
            </button>
        </div>
      </div>
      
    </div>

<!-- MODAL SURVEY IN DAY -->
<div class="modal fade" id="modalSurveyInDay" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
          <b>Activity in {{modalSurveyInDayTitle}}</b>
        &nbsp;
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" >
          <div style="width: 100%;height: 90vh;overflow-y: scroll;">
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 20%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    No.
                  </th>
                  <th scope="col" style="width: 80%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>Activity Data</span>                  
                  </th>
                </tr>
              </thead>
              <tbody >
                <!-- <tr> -->
                <tr v-for="(workData, index) in modalSurveyInDayData" v-bind:key="index">
                  <td style="padding:0px;border:1px solid black;vertical-align: middle;"
                  :style="{'background-color':(workData.work_type=='Survey'?'#82E0AA':'')}">
                    {{index+1}}
                  </td>
                  <td class="text-start" style="padding-left:5px;border:1px solid black;"
                  :style="{'background-color':(workData.work_type=='Survey'?'#82E0AA':'')}" >
                      <div v-if="workData.work_type=='Survey'">
                        <i class="fas fa-clock"></i> {{ formatTimeStr(workData.start_time) }} - {{ formatTimeStr(workData.end_time) }} <br>
                        <i class="fa-solid fa-list-check" style="color:red"></i><b>{{ workData.work_type+'('+ workData.name_la+')'}}</b><br>
                        <i class="fas fa-users"></i>{{ workData.cust_name }}, 
                        <i class="fas fa-question"></i> {{ workData.total_question }} Questions<br>
                        <i class="fa-solid fa-square-phone"></i>{{ workData.phone_number }}, 
                        <i class="fa-solid fa-map-location-dot"></i>{{ workData.remark_address }}<br>
                        
                      </div> 
                      <div v-else>
                        <i class="fas fa-clock"></i> {{ formatTimeStr(workData.start_time) }}<br>
                        <i class="fa-solid fa-gauge" style="color:purple"></i><b>{{ workData.work_type }}</b><br>
                        <i class="fa-solid fa-cloud-arrow-down"></i>{{ workData.download_speed }} Mbps,
                        <i class="fa-solid fa-cloud-arrow-up"></i>{{ workData.upload_speed }} Mbps,
                        <i class="fa-solid fa-link"></i>Ping {{ workData.ping }} Mls<br>
                          <div style="font-size: 10px;width: 100%;border: 1px solid black;">
                            {{ workData.ua }}
                          </div>
                      </div>
                      <i class="fas fa-location-dot"></i>
                      <a v-if="workData.lng" :href="'https://www.google.com/maps/search/?api=1&query='+workData.lat+','+workData.lng+''" target="_blank" >
                          (See device's location in the map)
                      </a>
                      <span v-else> - </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</div>
    
</template>
<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { Modal } from 'bootstrap'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'MyActivityReport',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
        userInfomation:'',
        userArea:'',
        months:[{'id':0,'name':'ມັງກອນ/January⁣'},
        {'id':1,'name':'ກຸມພາ/February'},
        {'id':2,'name':'ມີນາ/March'},
        {'id':3,'name':'ເມສາ/April'},
        {'id':4,'name':'ພຶດສະພາ/May'},
        {'id':5,'name':'ມີຖຸນາ/June'},
        {'id':6,'name':'ກໍລະກົດ/July⁣'},
        {'id':7,'name':'ສິງຫາ/August⁣'},
        {'id':8,'name':'ກັນຍາ/September⁣'},
        {'id':9,'name':'ຕຸລາ/October⁣'},
        {'id':10,'name':'ພະຈິກ/November⁣'},
        {'id':11,'name':'ທັນວາ/December⁣'}],
        selectedMonth:null,
        year:null,
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        weeksInCalendar: [],
        totalSurveyCase: 0,
        userId:null,
        getTotalWorkByUser:[],
        modalSurveyInDay:null,
        modalSurveyInDayTitle:"",
        modalSurveyInDayData:[]
    };
  },
  mounted() {
    var vm = this;
    var dateNow = new Date();  
    var monthIdNow = dateNow.getMonth();
    var currentMonthData = vm.months.filter(value => value.id == monthIdNow);
    vm.selectedMonth = currentMonthData[0];
    vm.year = dateNow.getFullYear();
    vm.clickBtnSearch();
    var userObject = JSON.parse(localStorage.getItem("userObj"));
    vm.userInfomation = userObject.user_code+", "+userObject.first_name_la+" "+userObject.surname_la;
    vm.userArea = userObject.province_la+", "+userObject.district_la;
    vm.userId = userObject.id;

    vm.modalSurveyInDay = new Modal(document.getElementById('modalSurveyInDay'));
    
 
  },
  methods: {
    clickBtnSearch: function(){
      var vm = this;
      vm.showLoading();
      vm.totalSurveyCase = 0;
      vm.createCalendar();
      setTimeout(() => {
        vm.getSurveyMaster();
      }, 300);
    },
    getSurveyMaster: async function(){
         var vm = this;
         var request = {};
            request["userId"] = vm.userId;
            request["month"] = vm.selectedMonth.id;
            request["year"] = vm.year;
         vm.showLoading();
            axios.post(Global.backendPath+"report/getSurveyMaster", request,
            {
                  headers: {
                  "Authorization": localStorage.getItem("token")
                  }
            })
            .then((response) => {
              if(response.status==200&&response.statusText=="OK"){
                  vm.getTotalWorkByUser = response.data.getTotalWorkByUser.result;
                  vm.mappingSuveyDataToCalendar(response.data.dailyTotalWorkToCalendar.result);
                  vm.calculateTotalSurveyCase(); 
              }
            vm.hideLoading();
            return response;
            }).catch((error) => {
            vm.hideLoading();
            console.log(error);
            vm.isTokenExpire(error);

            });
    },
    createCalendar() {
      const month = this.selectedMonth.id;
      const year = this.year;
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);
      const weeksInCalendarInMonth = [];

      let week = [];
      let day = firstDayOfMonth;
      //initial day of week since satturday
      for(var idx=0;idx<day.getDay();idx++){
        week.push({ date: null, dayInWeek: idx, dayInMonth: null})
      }

      //Append real date
      while (day <= lastDayOfMonth) {
        if (week.length && day.getDay() === 0) {
          weeksInCalendarInMonth.push(week);
          week = [];
        }
        week.push({ date: new Date(day), dayInWeek: day.getDay(), dayInMonth:day.getDate()});
        day.setDate(day.getDate() + 1);
      }

      if (week.length) {
        weeksInCalendarInMonth.push(week);
      }
      this.weeksInCalendar = weeksInCalendarInMonth;
    },
    mappingSuveyDataToCalendar:function(dailyTotalSurvey){
      var vm = this;
      //First loop is weeksInCalendar
      for(var idx=0;idx<vm.weeksInCalendar.length;idx++){
          var weekInCallendar = vm.weeksInCalendar[idx];
          //Second loop for day in week
            for(var idx2=0;idx2<weekInCallendar.length;idx2++){
              var dayInCallerdar = weekInCallendar[idx2];
              if(dayInCallerdar.date&&dayInCallerdar.dayInMonth){
                var surveyDataInDay = []
                if(dailyTotalSurvey){
                  //to find suvey case in this day
                  surveyDataInDay = dailyTotalSurvey.filter(value => value.work_day==dayInCallerdar.dayInMonth);
                }
                if(surveyDataInDay.length>0){
                  //Set total survey case
                  dayInCallerdar["totalSuveyCaseInDay"]=surveyDataInDay[0].total_survey_case;
                  dayInCallerdar["workDateStr"]=surveyDataInDay[0].work_date;
                }
              }
            }
      }

    },
    calculateTotalSurveyCase:function(){
      var vm = this;
      if(vm.getTotalWorkByUser){
        vm.getTotalWorkByUser.forEach(function(currentValue){
        vm.totalSurveyCase += currentValue.total;
        })
      }else{
        vm.totalSurveyCase = 0;
      }

    },
    clickDayInCalendar:async function(dayObj){
      var vm = this;
      if(dayObj.workDateStr){
        await vm.getSurveyReportDetails(dayObj.workDateStr);
        vm.modalSurveyInDayTitle = dayObj.workDateStr;
        vm.modalSurveyInDay.show();
      }
    },
    getSurveyReportDetails: async function(workDateStr){
         var vm = this;
         var userId = vm.userId;
         var startDate = "", endDate = "";
            startDate =workDateStr+" "+" 00:00:01"
            endDate = workDateStr+" "+" 23:59:59"
            var response = await vm.getSurveyDetails(userId,startDate,endDate);
              if(response.status==200&&response.statusText=="OK"){
                    vm.modalSurveyInDayData = response.data.result
              }
    },
    formatTimeStr:function(time){
      var timeAr = time.split(":");
      return timeAr[0]+":"+timeAr[1]
    },
    numToStr2Length:function(num){
      return num < 10 ? `0${num}` : `${num}`;
    },
    exportReportDetails: async function(){
         var vm = this;
         var userId = vm.userId;
         var month = vm.selectedMonth.id+1;
         var year = vm.year;
         var startDate = year+"-"+vm.numToStr2Length(month)+"-"+"01"+" 00:00:01"
         var endDate = year+"-"+vm.numToStr2Length(month+1)+"-"+"01"+" 00:00:01"
            var response = await vm.getSurveyDetails(userId,startDate,endDate);
              if(response.status==200&&response.statusText=="OK"){
                    var result = response.data.result
                    let csvString = vm.JSONtoCSV(result);
                    vm.downloadCSVFile(csvString, 'MySurveyReport('+year+"-"+vm.numToStr2Length(month)+').csv');
              }
    }




},
};
</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.nav-link.active {
  background-color: gray;
}
</style>
